import React, { useState } from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo accedo al ebook?',
  a: 'Una vez que realizás el pago, recibís un link de descarga inmediata por email. Accedés desde cualquier dispositivo.'
}, {
  q: '¿Sirve para cualquier tipo de vape?',
  a: 'Sí. El método está diseñado para cualquier tipo de vapeo: pods, mods, sales de nicotina, líquidos. El sistema ataca la raíz del hábito.'
}, {
  q: '¿Es seguro el pago?',
  a: 'Sí. Procesamos todos los pagos a través de Mercado Pago, la plataforma más segura de Argentina. Tenés 30 días de garantía.'
}];
export function EmotionalClose() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-6 md:py-24 px-4 bg-white" data-id="element-41">
      <div className="max-w-3xl mx-auto" data-id="element-42">
        <FadeIn data-id="element-43">
          <h2 className="font-display font-black text-3xl md:text-5xl text-gray-900 text-center mb-8 md:mb-12" data-id="element-44">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <StaggerContainer className="space-y-4" data-id="element-45">
          {faqs.map((faq, idx) => <StaggerItem key={idx} data-id="element-46">
              <div className="bg-gray-50 border border-gray-200 rounded-xl overflow-hidden" data-id="element-47">
                <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-4 md:p-6 text-left focus:outline-none" data-id="element-48">
                  <span className="font-display font-bold text-lg md:text-xl text-gray-900" data-id="element-49">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === idx ? 180 : 0
              }} transition={{
                duration: 0.2
              }} data-id="element-50">
                    <ChevronDown className="text-celeste" size={24} data-id="element-51" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-52">
                  {openIndex === idx && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} data-id="element-53">
                      <div className="p-4 md:p-6 pt-0 text-gray-600 text-base md:text-lg" data-id="element-54">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}